export default __webpack_public_path__ + "static/media/item-image.220d5307.png";